import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import flag_black_icon from 'assets/img/flag-black.svg';
import price_tag from 'assets/img/price-tag.svg';

import * as MaintenanceEnums from './maintenance-enums';
import * as ProjectActionType from 'Projects/constants';

class MaintenanceTaskImportGeneral extends React.Component {
    static propTypes = {
      projectId: PropTypes.string,
      dispatch: PropTypes.func,
      suggestedGeneralTaskList: PropTypes.array
    }

    constructor(props) {
      super(props);

      this.state = {
        filterOutItems: {}
      };
    }

    componentDidMount() {
      this.getSuggestMaintenanceGeneralTask(this.props.projectId);
    }

    // user events
    onClickAddButton = (id, isAdded) => {
      if (isAdded) { return; }

      this.props.dispatch({
        type: ProjectActionType.ADD_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC,
        params: {
          templateId: id,
          projectId: this.props.projectId
        },
        callback: () => {
          this.getSuggestMaintenanceGeneralTask(this.props.projectId);
        }
      });
    }

    // end user events

    // services
    compareGeneralTasks = (a, b) => {
      if ((a.isAdded && b.isAdded) || (!a.isAdded && !b.isAdded)) {
        return a.tag.localeCompare(b.tag);
      }

      return a.isAdded - b.isAdded;
    }

    // end services
    getSuggestMaintenanceGeneralTask = (projectId) => {
      this.props.dispatch({
        type: ProjectActionType.GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_ASYNC,
        params: {
          projectId: projectId
        }
      });
    }

    renderAddButton = (id, isAdded) => {
      return (
        <button
          className={isAdded ? 'btn btn-primary btn-siteone' : 'btn btn-siteone-default'}
          onClick={() => { this.onClickAddButton(id, isAdded); }}
        >
          {isAdded ? 'Added' : 'Add'}
        </button>
      );
    }

    searchTemplate = () => {
      if (this.boxSearchRef) {
        let filterOutItems = {};
        const keyword = this.boxSearchRef.value.toLowerCase();

        this.props.suggestedGeneralTaskList.map(e => {

          if (!e.name.toLowerCase().includes(keyword) &&
              !e.description.toLowerCase().includes(keyword) &&
              !e.tag.toLowerCase().includes(keyword)) {
            filterOutItems[e.id] = 1;
          }
        });

        this.setState({filterOutItems: filterOutItems});
      }
    }

    onKeyPress = (e) => {
      if (e.key === 'Enter') {
        this.searchTemplate();
      }
    }

    renderSearchBox = () => {
      return (
        <div className='box-search'>
          <div className='input-group combo'>
            <input
              type='text'
              className='form-control'
              placeholder='task name, tag'
              onKeyPress={this.onKeyPress}
              ref={ref => {this.boxSearchRef = ref;}}
            />
            <span className='input-group-btn'>
              <button className='btn btn-secondary' onClick={this.searchTemplate}>
                <span className='fa fa-search' />
              </button>
            </span>
          </div>
        </div>
      );
    }

    renderTaskList = () => {
      return (
        <div className='task-list'>
          {
            Array.isArray(this.props.suggestedGeneralTaskList) &&
            this.props.suggestedGeneralTaskList
              .sort((a,b) => this.compareGeneralTasks(a,b))
              .map((e, i) => {
                if (this.state.filterOutItems[e.id] === 1) {return null;}

                return (
                  <div key={e.id} className='row' >
                    <div className='col-md-8'>
                      <div style={{float: 'left'}}>
                        {this.renderAddButton(e.id, e.isAdded)}
                      </div>

                      <div className='block-with-text'>
                        <b>{e.name}</b><br/>
                        {e.description}
                      </div>
                    </div>

                    <div className='col-md-2' style={{paddingTop: '20px'}}>
                      <img className='icon' src={flag_black_icon} />
                      <div className='sub-block-text'>
                        {MaintenanceEnums.REPEAT_PERIODS_LIST[e.repeatType]}
                      </div>
                    </div>

                    <div className='col-md-2' style={{position: 'relative', paddingTop: '20px'}}>
                      <img className='icon' src={price_tag} />
                      <div className='sub-block-text'>
                        {e.tag}
                      </div>
                    </div>
                  </div>
                );
              })
          }
        </div>
      );
    }

    render() {
      return (
        <React.Fragment>
          {this.renderSearchBox()}
          {this.renderTaskList()}
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    suggestedGeneralTaskList: state.ProjectStore.SuggestedGeneralTaskList
  };
};

export default connect(mapStateToProps)(MaintenanceTaskImportGeneral);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-import-general.js